import http from "../http-common";
import authHeader from './auth-header';

class dealingService {
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PURCHASES

createPurchase(data) {
    return http.post("/dealing/a_purchases/create", data, { headers: authHeader() });
  }

  getAllPurchases() {
    return http.get("/dealing/a_purchases", { headers: authHeader() });
  }

  getSettlementDetails(data) {
    return http.post("/dealing/a_purchases/settlement_details", data, { headers: authHeader() });
  }

  checkIsWeekendHoliday(data) {
    return http.post("/dealing/a_purchases/is_weekend_holiday", data, { headers: authHeader() });
  }

  checkBrokerNoteIsUnique(data) {
    return http.post("/dealing/is_brokernote_unique", data, { headers: authHeader() });
  }

  getMMRate(data) {
    return http.post("/dealing/mm_rate", data, { headers: authHeader() });
  }

  getTenorDays(data) {
    return http.post("/dealing/a_purchases/tenor_days", data, { headers: authHeader() });
  }

  getMaturityDate(data) {
    return http.post("/dealing/a_purchases/maturity_date", data, { headers: authHeader() });
  }

  getCounters() {
    return http.get("/dealing/a_purchases/counters", { headers: authHeader() });
  }

  getGrossInterest(data) {
    return http.post("/dealing/a_purchases/gross_interest", data, { headers: authHeader() });
  }

  getUnlistedCounters() {
    return http.get("/dealing/a_purchases/unlisted_counters", { headers: authHeader() });
  }

  getPropUnitsBalance(data) {
    return http.post("/dealing/a_purchases/property_units_balance", data, { headers: authHeader() });
  }

  getCustodians(CurrencyID) {
    return http.get(`/dealing/custodians/${CurrencyID}`, { headers: authHeader() });
  }

  getDealNote(AllocationID, data) {
    return http.post(`/dealing/dealnote/${AllocationID}`, data, { headers: authHeader() });
  }

  getCustDealNote(PurchaseID, data) {
    return http.post(`/dealing/cust_dealnote/${PurchaseID}`, data, { headers: authHeader() });
  }

  getCustodianAccounts(CustodialID, data) {
    return http.post(`/dealing/custodians/accounts/${CustodialID}`, data, { headers: authHeader() });
  }

  getTransactionCharges(ModuleID, data) {
    return http.post(`/dealing/charges/${ModuleID}`, data, { headers: authHeader() });
  }

  getTransactionTaxes(ModuleID, data) {
    return http.post(`/dealing/taxes/${ModuleID}`, data, { headers: authHeader() });
  }

  getBalances(CustodialID, data) {
    return http.post(`/dealing/a_purchases/balances/${CustodialID}`, data, { headers: authHeader() });
  }

  getPurchase(PurchaseID) {
    return http.get(`/dealing/a_purchases/${PurchaseID}`, { headers: authHeader() });
  }

  updatePurchaseStatus(PurchaseID, data) {
    return http.put(`/dealing/a_purchases/update_status/${PurchaseID}`, data, { headers: authHeader() });
  }

  updatePurchase(PurchaseID, data) {
    return http.put(`/dealing/a_purchases/update/${PurchaseID}`, data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SALES

  createSale(data) {
    return http.post("/dealing/a_sales/create", data, { headers: authHeader() });
  }

  getAllSales() {
    return http.get("/dealing/a_sales", { headers: authHeader() });
  }

  getSale(SaleID) {
    return http.get(`/dealing/a_sales/${SaleID}`, { headers: authHeader() });
  }

  updateSaleStatus(SaleID, data) {
    return http.put(`/dealing/a_sales/update_status/${SaleID}`, data, { headers: authHeader() });
  }

  updateSale(SaleID, data) {
    return http.put(`/dealing/a_sales/update/${SaleID}`, data, { headers: authHeader() });
  }

  getCustodianHolding(data) {
    return http.post("/dealing/a_sales/custodian_holding", data, { headers: authHeader() });
  }

  getCurrentHolding(data) {
    return http.post("/dealing/a_sales/current_holding", data, { headers: authHeader() });
  }

  getAccountHolding(data) {
    return http.post("/dealing/a_sales/account_holding", data, { headers: authHeader() });
  }

  getRunningMMDeals(data) {
    return http.post("/dealing/a_sales/running_MMDeals", data, { headers: authHeader() });
  }

  getInstrumentDenominator(data) {
    return http.post("/dealing/a_sales/instrument_denominator", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ASSET TRANSFER EQUITY

  createAssetTransferEquity(data) {
    return http.post("/dealing/asset_transfers_equity/create", data, { headers: authHeader() });
  }

  getAllAssetTransfersEquity() {
    return http.get("/dealing/asset_transfers_equity", { headers: authHeader() });
  }

  updateAssetTransferEquity(TransferID, data) {
    return http.put(`/dealing/asset_transfers_equity/update/${TransferID}`, data, { headers: authHeader() });
  }

  deleteAssetTransferEquity(TransferID) {
    return http.delete(`/dealing/asset_transfers_equity/delete/${TransferID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MONEY MARKET SALE

  createMMSale(data) {
    return http.post("/dealing/mm_sale/create", data, { headers: authHeader() });
  }

  updateMMSaleStatus(SaleID, data) {
    return http.put(`/dealing/mm_sale/update_status/${SaleID}`, data, { headers: authHeader() });
  }

  getTerminationDirectives(data) {
    return http.post("/dealing/mm_sale/termination_directives", data, { headers: authHeader() });
  }

  getProprietaryAcc(data) {
    return http.post("/dealing/mm_sale/proprietary_account", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// REVERSALS

  captureUpdateReversal(data) {
    return http.post("/dealing/capture_update_reversal", data, { headers: authHeader() });
  }

  findAllReversals() {
    return http.get("/dealing/reversals", { headers: authHeader() });
  }

  initReversal(data) {
    return http.post("/dealing/init_reversal", data, { headers: authHeader() });
  }

  reversePurchase(data) {
    return http.post("/dealing/reverse_purchase", data, { headers: authHeader() });
  }

  reverseSale(data) {
    return http.post("/dealing/reverse_sale", data, { headers: authHeader() });
  }
}

export default new dealingService();